import type { ReactNode } from 'react';

interface PageHeaderProps {
  title: string;
  description?: ReactNode;
  action?: ReactNode; // Right-side action buttons (alias for children)
  children?: ReactNode; // For backwards compatibility with existing usage
  className?: string;
}

export default function PageHeader({ title, description, action, children, className }: PageHeaderProps) {
  // Support both 'action' and 'children' props (children takes precedence for backwards compat)
  const actions = children ?? action;

  return (
    <div className={`flex flex-col sm:flex-row sm:items-start sm:justify-between gap-4 ${className ?? ''}`}>
      <div>
        <h1 className="text-display-sm font-semibold text-ink">{title}</h1>
        {description && (
          <p className="mt-2 text-body-md text-muted">
            {description}
          </p>
        )}
      </div>
      {actions && (
        <div className="flex items-center gap-2 shrink-0">
          {actions}
        </div>
      )}
    </div>
  );
}